const navigation = [
  {
    name: 'cart',
    type: 'navigation',
    size: '25px'
  },
  {
    name: 'clear-fill',
    type: 'navigation',
    size: '25px'
  },
  {
    name: 'close',
    type: 'navigation',
    size: '25px'
  },
  {
    name: 'manage-boards',
    type: 'navigation',
    size: '25px'
  },
  {
    name: 'menu',
    type: 'navigation',
    size: '25px'
  },
  {
    name: 'notifications',
    type: 'navigation',
    size: '25px'
  },
  {
    name: 'notifications-alert',
    type: 'navigation',
    size: '25px'
  },
  {
    name: 'search',
    type: 'navigation',
    size: '25px'
  },
  {
    name: 'user',
    type: 'navigation',
    size: '25px'
  }
];

export default navigation;



// WEBPACK FOOTER //
// ./src/containers/foundations/Icons/constants/navigation.js